<template>
  <div>
    <el-dialog
      :visible.sync="checkParts"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      id="supple"
      :show-close="false"
    >
      <div class="part-check font-600">
        <span>温馨提示</span>
        <span class="title-font">系统检测到您未填写相关信息，请完善后继续</span>
        <img class="part-close" src="@/assets/test/part-close.png" alt @click="cancel" />
      </div>
      <div class="part-icon">
        <div class="box box1 box-bottom">
          <div class="qyname">会计制度：</div>
          <div class="name">
            <el-select v-model="zhidu" placeholder="请选择" :disabled="zhiduBoolean">
              <el-option
                v-for="item in kjzd"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="box box1 box-bottom">
          <div class="qyname">所属行业：</div>
          <div class="name">
            <el-select v-model="hangye" placeholder="请选择" filterable :disabled="hangyeBoolean">
              <el-option
                v-for="item in hyListDataShow"
                :key="item.hyDm"
                :label="item.hymc"
                :value="item.hyDm"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="part-btnC">
        <div class="part-btn ease" @click="sumbit">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTradeList, getbasicinfo } from "@/api/api";
export default {
  data() {
    return {
      hangye: "",
      morehy: "",
      zhidu: "",
      hyList: [],
      hyList2: [],
      kjzd: [
        { value: "qykjzd", label: "企业会计制度" },
        { value: "qykjzz", label: "企业会计准则" },
        { value: "xqykjzz", label: "小企业会计准则" },
      ],
      hyListDataShow: null,
      zhiduBoolean: false,
      hangyeBoolean: false,
    };
  },
  props: ["checkParts"],
  created() {
    this.gettradeList();
    this.getBasicinfo();
  },
  methods: {
    // 获取企业信息
    getBasicinfo() {
      let user = JSON.parse(localStorage.getItem("user"));
      if (!user) return;
      let id = user.companyId;
      getbasicinfo(id).then((res) => {
        if (res.msgCode == 1) {
          this.zhidu = res.data.kjzd;
          this.hangye = res.data.hy;
          this.zhidu ? (this.zhiduBoolean = true) : (this.zhiduBoolean = false);
          this.hangye
            ? (this.hangyeBoolean = true)
            : (this.hangyeBoolean = false);
        } else {
          this.$message.error(res.msgInfo);
        }
      });
    },

    // 获取行业
    gettradeList() {
      getTradeList().then((res) => {
        if (res.msgCode == 1) {
          if (!res.data) {
            this.$message.error(res.msgInfo);
          }
          let hyList = JSON.parse(res.data);
          let dataList = {};
          for (let i = 0; i < hyList.length; i++) {
            hyList[i].hymc = hyList[i].hyDm + hyList[i].hymc;
            dataList[hyList[i].hyDm] = hyList[i].hymc;
          }
          this.hyListDataShow = hyList;
        } else {
          this.$message.error(res.msgInfo);
        }
      });
    },
    sumbit() {
      if (!this.zhidu || !this.zhidu.trim()) {
        this.$message.error({
          message: "会计制度不能为空！",
        });
        return;
      }
      if (!this.hangye || !this.hangye.trim()) {
        this.$message.error({
          message: "行业不能为空！",
        });
        return;
      }
      this.$emit("submit", { morehy: this.hangye, zhidu: this.zhidu });
    },
    cancel() {
      this.$emit("cancel", this.checkParts);
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> #supple .el-dialog {
  width: 480px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

>>> #supple .el-dialog__header {
  padding: 0;
}

>>> #supple .el-dialog__body {
  padding: 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
}

.part-check {
  width: 100%;
  height: 54px;
  line-height: 54px;
  border-bottom: 1px solid #eeeeee;
  padding-left: 24px;
  box-sizing: border-box;
  align-item: center;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
}

.part-close {
  position: relative;
  top: 18px;
  float: right;
  padding-right: 24px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
  width: 14px;
  height: 14px;
  cursor: pointer;
}

.part-icon {
  text-align: center;
  border-bottom: 1px solid #eeeeee;
  box-sizing: border-box;
  padding-left: 50px;
  padding-top: 32px;
  padding-bottom: 16px;
}

.box {
  display: flex;
}

.part-btn {
  position: relative;
  right: 24px;
  top: 16px;
  width: 76px;
  height: 36px;
  line-height: 36px;
  background: rgba(47, 84, 235, 1);
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  float: right;
  cursor: pointer;
}

.part-btn:hover {
  background: rgba(47, 60, 235, 1);
}

.ease {
  transition: all 0.3s;
}

.title-font {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.4);
  margin-left: 8px;
}

.qyname {
  width: 100px;
  line-height: 40px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

.el-select {
  width: 284px;
}

.part-btnC {
  height: 68px;
}

.box-bottom {
  margin-bottom: 16px;
}
</style>
